export default __webpack_public_path__ + "static/media/vBtcb.c0261288.svg";